import { useContext } from "react";
import { Context } from "../context";
import { breakpoint1, mediumFont } from "../utils/styles";
import { BareFacebookMessengerIcon } from "../utils/icons";

const BannerAd = () => {
  const { theme } = useContext(Context);
  return (
    <div className="banner-ad">
      <style jsx>{`
        .banner-ad {
          display: none;
          background: #fff;
          border-bottom: 1px solid ${theme.borderColor};
        }
        .banner-ad h3 {
          color: #177fff;
          font-size: ${mediumFont};
        }
        /*@media screen and (min-width: ${breakpoint1}px) {
          .banner-ad {
            width: 100%;

            font-size: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 10rem;
            font-size: 1.5rem;
          }

        }*/
      `}</style>
      <h3>Get Updates, Follow AppCheeta on Facebook</h3>
      <BareFacebookMessengerIcon />
    </div>
  );
};

export default BannerAd;
